import { useState, useRef } from "react";
import { toast } from "sonner";
import { QRCodeSVG } from "qrcode.react";
import { Copy, QrCode, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

async function qrPng(svgEl) {
  const xml = new XMLSerializer().serializeToString(svgEl);
  const img = new Image();
  await new Promise((res) => { img.onload = res; img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(xml))); });
  const c = document.createElement("canvas"); c.width = c.height = 480;
  const x = c.getContext("2d"); x.fillStyle = "#fff"; x.fillRect(0, 0, 480, 480); x.drawImage(img, 40, 40, 400, 400);
  return new Promise((res) => c.toBlob(res, "image/png"));
}

export function UserCodeCard() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const svgRef = useRef();
  if (!user?.user_code) return null;
  const link = `${window.location.origin}/wallet?to=${user.user_code}`;
  const copy = () => { navigator.clipboard?.writeText(user.user_code); toast.success("Código copiado"); };
  const share = async () => {
    const text = `Envíame saldo en CubiMarket & Pay con mi código ${user.user_code}: ${link}`;
    try {
      const svg = svgRef.current?.querySelector("svg");
      const blob = svg ? await qrPng(svg) : null;
      const file = blob ? new File([blob], `${user.user_code}.png`, { type: "image/png" }) : null;
      if (navigator.share && file && navigator.canShare?.({ files: [file] })) { await navigator.share({ title: "Mi código CubiMarket", text, files: [file] }); return; }
      if (navigator.share) { await navigator.share({ title: "Mi código CubiMarket", text, url: link }); return; }
      if (blob) { const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = `${user.user_code}.png`; a.click(); }
      await navigator.clipboard?.writeText(text); toast.success("Enlace copiado y QR descargado");
    } catch (e) { if (e?.name !== "AbortError") { navigator.clipboard?.writeText(text); toast.success("Enlace de pago copiado"); } }
  };
  return (
    <div className="neon-card p-4 space-y-3" data-testid="user-code-card">
      <div className="flex items-center justify-between gap-2">
        <div><div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Mi código de usuario</div><div className="font-mono text-2xl font-bold text-cyan-300 tracking-wider" data-testid="user-code">{user.user_code}</div><div className="text-xs text-muted-foreground">Sirve para recibir pagos sin comisión y mensajes de otros usuarios.</div></div>
        <div className="flex gap-1"><Button size="icon" variant="outline" onClick={copy} data-testid="user-code-copy"><Copy size={16} /></Button><Button size="icon" variant="outline" onClick={() => setOpen((o) => !o)} data-testid="user-code-qr-toggle"><QrCode size={16} /></Button><Button size="icon" variant="outline" onClick={share} data-testid="user-code-share"><Share2 size={16} /></Button></div>
      </div>
      <div ref={svgRef} className={open ? "flex flex-col items-center gap-2" : "hidden"}><div className="bg-white p-3 rounded-2xl" data-testid="user-code-qr"><QRCodeSVG value={link} size={180} /></div><div className="text-[11px] text-muted-foreground break-all text-center" data-testid="user-code-link">{link}</div></div>
    </div>
  );
}
